import axios from '../utils/axios';

export default function getDomainFromCustId(adminId, custId) {
    return (
        axios.get(`/admin/${adminId}/custDetails`, { params: { custId } })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            })
    )
}
